/*
 * @Author: Json Chen
 * @Date: 2021-07-14 13:33:39
 * @LastEditTime: 2021-07-14 13:34:46
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/config.ts
 */

import { SFLocation } from './type';

export const locationList = [
  {
    label: 'Mainland China',
    value: SFLocation.CN,
  },
  {
    label: 'Hong Kong SAR & Macau SAR',
    value: SFLocation.HK_MO,
  },
];
